import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import PropTypes from "prop-types";
import {
  Autocomplete,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { formFieldError } from "../../../modules/hcmd/components/formUtils";
import { getCountriesAutocomplete } from "../../../services/dictionary";
import Grid from "@mui/material/Unstable_Grid2";

const FilterNationalityForwardRef = (props, ref) => {
  const { params } = props;

  useImperativeHandle(ref, () => ({
    getFilter() {
      return {
        userHc: { nationalityId: { inq: values.map((item) => item.id) } },
      };
    },
    getValue() {
      if (!values.length) return null;
      return values.map((v) => ({ id: v.id, nationality: v.nationality }));
    },
    getDisplayValue() {
      if (!values.length) return null;
      const names = values.map((v) => v.nationality);
      const head = names.slice(0, 2).join(", ");
      const more = names.length > 2 ? ` +${names.length - 2}` : "";
      return `${params.name}: ${head}${more}`;
    },
  }));

  const [values, setValues] = useState(
    Array.isArray(params.initialValue) ? params.initialValue : []
  );

  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  let optionTimer;

  return (
    <Grid container spacing={2}>
      <Grid>
        <label className={` col-form-label fw-bold fs-6`}>{params.name}</label>
      </Grid>
      <Grid className={`fv-row`}>
        <FormControl sx={{ width: "100%" }}>
          <Autocomplete
            name={params.field}
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            multiple={true}
            // freeSolo={true}
            options={options}
            isOptionEqualToValue={(option, value) => {
              return option.id === value;
            }}
            getOptionLabel={(option) => option.nationality ?? ""}
            filterOptions={(x) => {
              return x;
            }}
            onInputChange={(event, value) => {
              clearTimeout(optionTimer);
              optionTimer = setTimeout(() => {
                if (value) {
                  getCountriesAutocomplete(value)
                    .then((response) => {
                      setOptions(response.data);
                    })
                    .catch((err) => console.error(err));
                } else {
                  setOptions([]);
                }
              }, 200);
            }}
            onChange={(event, value) => {
              setValues(value ?? []);
            }}
            value={values}
            renderInput={(params) => (
              <TextField {...params} placeholder={"Több is választható"} />
            )}
          ></Autocomplete>
        </FormControl>
      </Grid>
    </Grid>
  );
};
const FilterNationality = forwardRef(FilterNationalityForwardRef);

FilterNationality.propTypes = {
  params: PropTypes.object,
};

export default FilterNationality;
